module.exports = "./img/7250931e64179ab6e84a6ea77943b958.jpg";